import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <p>&copy; 2026 AWS Community GameDay. All rights reserved.</p>
        <p>An event organized by and for the AWS community.</p>
      </div>
    </footer>
  );
};

export default Footer;